import React from "react";

function TextRenderer({ text }) {

    if (!text) {

        return null;

    }

    return (

        <div

            style={{

                background: "#ffffff",

                border: "1px solid #e5e7eb",

                borderRadius: 10,

                padding: 14,

                marginTop: 10,

                marginBottom: 15,

                lineHeight: 1.6,

                whiteSpace: "pre-wrap",

                color: "#222",

                fontSize: 14

            }}

        >

            {text}

        </div>

    );

}

export default TextRenderer;